module.exports = __webpack_public_path__ + "img/factura1.0cc41719.png";